export default {
  signature: {
    qa: 'Kontrola kvality',
    lab: 'Laboratórium',
  },
  errors: {
    downloadPdfFailed: 'Nepodarilo sa stiahnuť správu o kvalite pre {report}. Ak sa chyba opakuje, kontaktujte technickú podporu Qmulus',
  },
};
